module.exports = __webpack_public_path__ + "static/media/wallet.4dbee683.png";